import useDocumentTitle from "@/hooks/useDocumentTitle";
import { Link } from "react-router-dom";
import { ArrowLeft, MapPin, Mail, Phone } from "lucide-react";

function Field({ label, value }) {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-3 gap-2 py-3 border-b border-ink/10">
      <dt className="font-mono-overline text-mute">{label}</dt>
      <dd className="sm:col-span-2 text-ink">{value}</dd>
    </div>
  );
}

export default function MentionsLegalesPage() {
  useDocumentTitle("Mentions légales", "Mentions légales de SHINRAI CONSULTING. Identification, hébergement, données personnelles, propriété intellectuelle.");
  return (
    <main className="pt-28 pb-24 bg-pearl min-h-screen" data-testid="mentions-legales-page">
      <article className="max-w-3xl mx-auto px-6 sm:px-10">
        <Link to="/" className="inline-flex items-center gap-2 text-sm text-mute hover:text-ink transition mb-10">
          <ArrowLeft size={14} /> Retour à l'accueil
        </Link>

        <div className="font-mono-overline text-mute mb-3">Légal</div>
        <h1 className="font-serif text-5xl leading-tight mb-12">Mentions légales</h1>

        <section className="mb-12">
          <h2 className="font-serif text-2xl mb-4">Éditeur du site</h2>
          <dl>
            <Field label="Dénomination" value="SHINRAI CONSULTING" />
            <Field label="Forme juridique" value="Société par Actions Simplifiée (SAS)" />
            <Field label="Capital social" value="104 996,00 €" />
            <Field label="SIREN" value="803 535 269" />
            <Field label="SIRET (siège)" value="803 535 269 00010" />
            <Field label="RCS" value="Nanterre — n° 803 535 269" />
            <Field label="N° TVA intracommunautaire" value="FR 37 803 535 269" />
            <Field label="Site internet" value="shinrai.fr (alias : shinrai.consulting)" />
            <Field label="Directeur de la publication" value="Le représentant légal de SHINRAI CONSULTING" />
          </dl>
        </section>

        <section className="mb-12">
          <h2 className="font-serif text-2xl mb-4">Établissements</h2>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
            <div className="bg-white border border-ink/10 p-6">
              <div className="font-mono-overline text-mute mb-3">France hexagonale — Siège</div>
              <div className="space-y-2 text-sm">
                <p className="flex items-start gap-2 text-ink"><MapPin size={14} className="mt-1 flex-shrink-0" /> 2, Avenue Anatole France — 92110 Clichy</p>
                <p className="flex items-center gap-2 text-ink"><Phone size={14} /> +33 1 87 66 19 47</p>
                <p className="flex items-center gap-2 text-ink"><Mail size={14} /> <a className="underline hover:no-underline" href="mailto:info@shinrai.fr">info@shinrai.fr</a></p>
              </div>
            </div>

            <div className="bg-white border border-ink/10 p-6">
              <div className="font-mono-overline text-mute mb-3">France Océan Indien</div>
              <div className="space-y-2 text-sm">
                <p className="flex items-start gap-2 text-ink"><MapPin size={14} className="mt-1 flex-shrink-0" /> 25, rue des Nénuphars — 97430 Le Tampon, Île de la Réunion</p>
                <p className="flex items-center gap-2 text-ink"><Phone size={14} /> +262 262 66 76 84</p>
                <p className="flex items-center gap-2 text-ink"><Mail size={14} /> <a className="underline hover:no-underline" href="mailto:info@shinrai.fr">info@shinrai.fr</a></p>
              </div>
            </div>
          </div>
        </section>

        <section className="mb-12">
          <h2 className="font-serif text-2xl mb-4">Hébergeur</h2>
          <dl>
            <Field label="Nom" value="Emergent Labs" />
            <Field label="Site web" value="emergent.sh" />
          </dl>
        </section>

        <section className="mb-12">
          <h2 className="font-serif text-2xl mb-4">Propriété intellectuelle</h2>
          <p className="text-mute leading-relaxed">
            L'ensemble du site (textes, images, charte graphique, logo, vidéos, méthode <strong>SHINRAI™</strong>, marques associées) est protégé par
            le droit d'auteur et le droit des marques. Toute reproduction, représentation, modification, publication, transmission ou
            dénaturation, totale ou partielle, sur quelque support que ce soit, est strictement interdite sans autorisation écrite préalable
            de SHINRAI CONSULTING. Tout usage non autorisé pourra faire l'objet de poursuites judiciaires.
          </p>
        </section>

        <section className="mb-12">
          <h2 className="font-serif text-2xl mb-4">Données personnelles</h2>
          <p className="text-mute leading-relaxed mb-4">
            Conformément au Règlement (UE) 2016/679 (RGPD) et à la loi Informatique et Libertés modifiée, l'utilisateur dispose d'un droit
            d'accès, de rectification, d'effacement, de portabilité et d'opposition concernant ses données personnelles.
          </p>
          <p className="text-mute leading-relaxed">
            Pour exercer ces droits, contacte-nous à <a className="underline" href="mailto:info@shinrai.fr">info@shinrai.fr</a>.
            Une réponse te sera apportée sous un délai maximal de 30 jours.
          </p>
        </section>

        <section className="mb-12">
          <h2 className="font-serif text-2xl mb-4">Responsabilité</h2>
          <p className="text-mute leading-relaxed">
            SHINRAI CONSULTING s'efforce d'assurer l'exactitude et la mise à jour des informations diffusées sur ce site. Toutefois,
            SHINRAI CONSULTING ne peut garantir l'exactitude, la précision ou l'exhaustivité des informations mises à disposition.
            En conséquence, SHINRAI CONSULTING décline toute responsabilité pour toute imprécision, inexactitude ou omission portant
            sur des informations disponibles sur le site, ainsi que pour tout dommage résultant d'une intrusion frauduleuse d'un tiers
            ayant entraîné une modification des informations mises à disposition.
          </p>
        </section>

        <p className="text-xs text-mute mt-12">Dernière mise à jour : décembre 2025</p>
      </article>
    </main>
  );
}
